import type { ShaclViolation } from '@cogo/kg-browser'
import type { ValidationStatus } from '@/features/validation/types'

export interface AppValidationReport {
  status: ValidationStatus
  totalRules: number
  totalViolations: number
  pass: number
  violations: number
  warnings: number
  blocks: PerBlockResult[]
  rows: ValidatorRowEntry[]
  durationMs: number
  fromLocal: boolean
}

export interface PerBlockResult {
  blockId: string
  blockName: string
  phases: {
    structural: PhaseResult
    binding: PhaseResult
  }
}

export interface PhaseResult {
  violations: ShaclViolation[]
  durationMs: number
  rulesEvaluated: number
}

export interface ValidatorRowEntry {
  gate: 'structural' | 'binding'
  ruleId: string
  ruleLabel: string
  passCount: number
  failCount: number
  warnCount: number
  status: 'success' | 'destructive' | 'warning'
}

export function deriveStatus(counts: {
  violations: number
  warnings: number
}): Exclude<ValidationStatus, 'idle'> {
  if (counts.violations > 0) return 'fail'
  if (counts.warnings > 0) return 'warn'
  return 'pass'
}
